import chain from '@/lib/axios-chain'
// 获取团队组织结构列表
export const getLevelList = () => chain.create('/data/index/level', 'get')
// 获取来源信息数据
export const getMessageSource = () => chain.create('/data/index/from', 'get')
// 获取首页详细数据
export const getIndexDetailDatas = () =>
  chain.create('/data/index/detail', 'post')
// 获取顶部概览数据
export const getIndexHeadDatas = () => chain.create('/data/index/head', 'post')
// 获取成员范围数据--开发
export const getMemberRangeDatas = () =>
  chain.create('/data/developer/member', 'get')
// 获取成员范围数据--接待
export const getMemberRecRangeDatas = () =>
  chain.create('/data/receptionist/member', 'get')
  // 获取审核成员范围数据--接待
export const getMemberRecAuditRangeDatas = () =>
  chain.create('/data/audit/member', 'get')
// 获取成员范围数据
export const getMemberFollowRangeDatas = () =>
  chain.create('/data/sales/member', 'get')
// 获取开发概览数据
export const getDevOverView = () => chain.create('/data/developer/view', 'post')
// 获取接待录入统计概览数据
export const getRecOverView = () =>
  chain.create('/data/receptionist/view', 'post')
  // 获取接待审核统计概览数据
export const getRecAuditOverView = () =>
  chain.create('/data/audit/view', 'post')
// 获取开发趋势数据
export const getDTendencyDatas = () =>
  chain.create('/data/developer/trend', 'post')
// 获取接待趋势数据
export const getRTendencyDatas = () =>
  chain.create('/data/receptionist/trend', 'post')
  // 获取接待审核趋势数据
export const getRAuditTendencyDatas = () =>
  chain.create('/data/audit/trend', 'post')
// 获取跟进概览数据
export const getFollowDataOverview = () =>
  chain.create('/data/sales/view', 'post')
// 获取开发分布数据
export const getDevDistributeDatas = () =>
  chain.create('/data/developer/distribution', 'post')
// 获取跟进趋势数据
export const getFollowTendencyDatas = () =>
  chain.create('/data/sales/trend', 'post')
// 获取开发-跟进-接待详细数据
export const getDetailTableDatas = () =>
  chain.create('/data/developer/detail', 'post')
export const getDetailRecTableDatas = () =>
  chain.create('/data/receptionist/detail', 'post')

// pc端录入统计数据模块
export const getDetailRecTablePcDatas = () =>
  chain.create('/data/receptionist/detailt', 'post')

// pc端录入统计数据模块信息来源数据筛选
export const getDetailRecFromInfoPcDatas = () =>
  chain.create('/data/receptionist/getFrom', 'get')

// pc端审核统计数据模块
export const getDetailRecAuditTablePcDatas = () =>
  chain.create('/data/audit/detailt', 'post')
// 移动端审核统计数据模块
export const getDetailRecAuditTableMobileDatas = () =>
  chain.create('/data/audit/detail ', 'post')

export const getFollowDetailTableDatas = () =>
  chain.create('/data/sales/detail', 'post')

// 获取首页导出链接数据
export const getExportLinkUrl = () => chain.create('/data/index/geturl', 'post')
// 获取首页筛选项信息
export const getIndexFilterDatas = () =>
  chain.create('/data/index/filter', 'get')
// 获取数据类型列表
export const getStaticType = () => chain.create('/config/getConfigByFieldkey', 'get')

// 获取数据类型列表
export const getDetailTableDatasPc = () => chain.create('/data/developer/detailt', 'post')

// 信息接待统计 录入和审核权限
export const getRecStatisticPermission = () => chain.create('/data/receptionist/getWeAuth', 'get')
